import { useState } from 'react';

import { DisplayComponent } from '@/components/DisplayComponent';
import { DisplayHeading } from '@/components/DisplayHeading';
import { Header } from '@/components/Header';
import { ProgressBar } from '@/components/ProgressBar';
import { ELoanUsage, EUserFlow, selectLoanUsage } from '@/context/borrower';
import { selectIsAssetKnownViaParams, selectUserFlow } from '@/context/display';
import { store } from '@/context/store';
import { useAppSelector } from '@/context/storeHooks';
import { LivingStatus } from '@/UserInput';
import { AnnualKms } from '@/UserInput/AnnualKms';
import { CampaignVehicleDropdown } from '@/UserInput/CampaignVehicleDropdown';
import { HaveKids } from '@/UserInput/HaveKids';
import { MarriageStatus } from '@/UserInput/MarriageStatus';
import { ResidencyStatus } from '@/UserInput/ResidencyStatus';

import { BasicDetailsButtons } from './BasicDetailsButtons';

export const testId = 'screen-basicDetails';

export function BasicDetails(): JSX.Element {
    // ***** Local State *****
    const [showErrors, setShowErrors] = useState(false);
    const loanUsage = useAppSelector(selectLoanUsage);
    const userFlow = useAppSelector(selectUserFlow);
    const isKnown = useAppSelector(selectIsAssetKnownViaParams);

    // ***** CONSTANTS *****
    const baseId = 'screen-basicDetails';
    const state = store.getState();
    const isNovatedLease =
        state.borrowerReducer.loan.loanUsage === ELoanUsage.NOVATED;
    const isBrandNovated = state.displayReducer.partner.isNovatedLease;

    return (
        <div data-testid={testId}>
            <DisplayComponent baseId={baseId}>
                <Header />
                <ProgressBar />
                <DisplayHeading
                    title='Basic Details'
                    infoText='We just need to ask some basic details about you'
                />
                {/* <Gender showErrors={showErrors} baseId={baseId} /> */}
                {userFlow === EUserFlow.CAMPAIGN && !isKnown && (
                    <CampaignVehicleDropdown
                        baseId={baseId}
                        showErrors={showErrors}
                    />
                )}

                <LivingStatus showErrors={showErrors} baseId={baseId} />
                <MarriageStatus showErrors={showErrors} baseId={baseId} />
                <ResidencyStatus showErrors={showErrors} baseId={baseId} />
                {loanUsage !== ELoanUsage.BUSINESS && (
                    <HaveKids showErrors={showErrors} baseId={baseId} />
                )}
                {isBrandNovated && isNovatedLease && (
                    <AnnualKms showErrors={showErrors} baseId={baseId} />
                )}
                <BasicDetailsButtons
                    setShowErrors={setShowErrors}
                    baseId={baseId}
                />
            </DisplayComponent>
        </div>
    );
}
